// @ts-check
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { getPendingPayouts } from "./";

export default function useGetPendingPayouts() {
  const { sessionJWT } = useSessionJWT();

  const fetchPendingPayouts = useCallback(async () => {
    const data = await getPendingPayouts(sessionJWT);
    return data;
  }, [sessionJWT]);

  return useQuery({
    queryKey: ["pendingPayouts"],
    queryFn: fetchPendingPayouts
  });
}
